import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:teamId/invite-emails(/:view)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/InviteEmailContainer',
      './modules/InviteEmail'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const InventoryReports = require('./containers/InviteEmailContainer').default
      const actions = require('./modules/InviteEmail')
      const reducer = require('./modules/InviteEmail').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'templateEmails', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId, nextState.params.view))

      /*  Return getComponent   */
      cb(null, InventoryReports)

    /* Webpack named bundle   */
    }, 'templateEmails')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/components/InviteEmail/index.js